import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const handleGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(form.email, form.password);
      toast.success("Welcome back!");
      nav("/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-16">
      <div className="nb-card p-8">
        <h1 className="text-4xl font-extrabold">Welcome back</h1>
        <p className="text-neutral-600 mt-1">Pick up where you left off.</p>

        <button data-testid="login-google" onClick={handleGoogle} className="w-full mt-6 nb-btn nb-btn-secondary">
          <img src="https://www.gstatic.com/marketing-cms/assets/images/d5/dc/cfe9ce8b4425b410b49b7f2dd3f3/g.webp" alt="G" className="w-4 h-4" />
          Continue with Google
        </button>
        <div className="my-4 flex items-center gap-2 text-xs text-neutral-500"><div className="flex-1 h-px bg-black" />OR<div className="flex-1 h-px bg-black" /></div>

        <form onSubmit={submit} className="space-y-3">
          <input data-testid="login-email" className="nb-input" type="email" placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required />
          <input data-testid="login-password" className="nb-input" type="password" placeholder="Password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required />
          <button data-testid="login-submit" type="submit" disabled={loading} className="w-full nb-btn">{loading ? "Signing in…" : "Log in"}</button>
        </form>
        <p className="text-sm text-center mt-4">New here? <Link data-testid="login-signup-link" to="/signup" className="font-bold underline">Create account</Link></p>
      </div>
    </div>
  );
}
